import { format } from "date-fns";
import React from "react";
import { Link } from "react-router-dom";
import { useGetVideoQuery } from "../../../features/videos/videosApi";
import { useSelector } from "react-redux";
import { useGetQuizMarkQuery } from "../../../features/quizMark/quizMarkApi";
import { useGetQuizQuery } from "../../../features/quizzes/quizzesApi";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import {
  useCreateAssignmentMarkMutation,
  useGetAssignmentMarkQuery,
} from "../../../features/assignmentMark/assignmentMarkApi";
import { useGetAssignmentQuery } from "../../../features/assignments/assignmentsApi";

const MySwal = withReactContent(Swal);

const Video = () => {
  const { selectedVideo, id, name } = useSelector((state) => state?.auth?.user);
  const {
    data: video,
    isLoading,
    isError,
    error,
  } = useGetVideoQuery(selectedVideo);
  const { data: quizzes } = useGetQuizQuery(selectedVideo);

  const { data: quizMark, isLoading: isQuizLoading } = useGetQuizMarkQuery({
    video_id: selectedVideo,
    student_id: id,
  });
  
  const { data: assignment } = useGetAssignmentQuery(selectedVideo);
  const { data: assignmentMark } = useGetAssignmentMarkQuery({
    assignment_id:  assignment?.length > 0 ? assignment[0]?.id : null,
    student_id: id,
  });

  const [submitAssignment] = useCreateAssignmentMarkMutation();

  const handleSubmitAssignment = async () => {
    await MySwal.fire({
      width: 600,
      showCancelButton: true,
      confirmButtonText: "Submit Assignment",
      showLoaderOnConfirm: true,
      background: "#080E1B",
      html: `
      <div class="flex flex-col gap-y-2">
        <label for="repo" class="text-white text-left my-3 font-semibold">Github Repository Link</label>
        <input required id="repo" placeholder="Enter your assignment github repository link" class="input input-bordered input-primary w-full text-white" value="" />
      </div>
      `,
      focusConfirm: false,
      preConfirm: () => {
        return {
          repo: document.getElementById("repo").value,
        };
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const { repo } = result.value;
        if (!repo) {
          MySwal.fire({
            icon: "error",
            title: "<span class='text-white'>Oops...</span>",
            text: "All fields are required",
            background: "#080E1B",
          });
          return;
        }
        const createdAt = new Date().toISOString();

        const assignment_id = assignment[0]?.id;
        const title = assignment[0]?.title;

        const info = {
          student_id: id,
          student_name: name,
          assignment_id: assignment_id,
          title: title,
          createdAt: createdAt,
          totalMark: 100,
          mark: 0,
          repo_link: repo,
          status: "pending",
        };

        submitAssignment(info);
      }
    });
  };

  // decide what to show based on the state
  let content = null;
  if (isLoading) {
    content = <div>Loading...</div>;
  }
  if (!isLoading && isError) {
    content = <div>{error.message}</div>;
  }
  if (!isLoading && !isQuizLoading && !isError && video.id) {
    const { id, title, description, url, views, duration, createdAt } =
      video || {};
    content = (
      <div className="col-span-full w-full space-y-8 lg:col-span-2">
        <iframe
          width="100%"
          className="aspect-video"
          src={url}
          title={title}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>

        <div>
          <h1 className="text-lg font-semibold tracking-tight text-slate-100">
            {title}
          </h1>
          <h2 className=" pb-4 text-sm leading-[1.7142857] text-slate-400">
            Uploaded on {format(new Date(createdAt), "dd MMMM yyyy")}
          </h2>

          <div className="flex gap-4">
            {assignmentMark?.length > 0 ? (
              <button className="px-3 font-bold py-1 border border-yellow-500 text-yellow-500 rounded-full text-sm cursor-default">
                এসাইনমেন্ট জমা দেয়া হয়েছে
              </button>
            ) : assignment?.length > 0 ? (
              <button
                onClick={handleSubmitAssignment}
                className="px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary"
              >
                এসাইনমেন্ট
              </button>
            ) : (
              <button className="px-3 font-bold py-1 border border-red-500 text-red-500 rounded-full text-sm cursor-default">
                এসাইনমেন্ট নেই
              </button>
            )}
            {quizzes?.length > 0 ? (
              !quizMark?.length > 0 ? (
                <Link
                  to={`/quiz/${id}`}
                  className="px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary"
                >
                  কুইজে অংশগ্রহণ করুন
                </Link>
              ) : (
                <span className="px-3 font-bold py-1 border border-yellow-500 text-yellow-500 rounded-full text-sm cursor-default">
                  কুইজে অংশগ্রহণ করেছেন
                </span>
              )
            ) : (
              <span className="px-3 font-bold py-1 border border-red-500 text-red-500 rounded-full text-sm cursor-default">
                কুইজ নেই
              </span>
            )}
          </div>
          <p className="mt-4 text-sm text-slate-400 leading-6">{description}</p>
        </div>
      </div>
    );
  }

  return content;
};

export default Video;
